import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _JSXStyle from "styled-jsx/style";
import { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { get } from '@cullylarson/f';
import { preventDefault } from '@@client/lib/events';
import { kinds, markNotificationShown, removeNotification } from './actions';
import CloseButton from '@@client/components/CloseButton';

var mapStateToProps = function mapStateToProps(_ref) {
  var notification = _ref.notification;
  return {
    notifications: notification.notifications
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      markNotificationShown: markNotificationShown,
      removeNotification: removeNotification
    }, dispatch)
  };
};

var Notifications = function Notifications(_ref2) {
  var _kindToClassName, _kindToRole;

  var actions = _ref2.actions,
      notifications = _ref2.notifications;
  useEffect(function () {
    notifications.forEach(function (x) {
      if (!x.isShown) {
        actions.markNotificationShown(x.id);

        if (x.options.autoDismiss) {
          setTimeout(function () {
            actions.removeNotification(x.id);
          }, x.options.dismissTimeout);
        }
      }
    });
  }, [notifications]);
  var kindToClassName = (_kindToClassName = {}, _defineProperty(_kindToClassName, kinds.ERROR, 'kind-error'), _defineProperty(_kindToClassName, kinds.NOTICE, 'kind-notice'), _defineProperty(_kindToClassName, kinds.SUCCESS, 'kind-success'), _kindToClassName);
  var kindToRole = (_kindToRole = {}, _defineProperty(_kindToRole, kinds.ERROR, 'alert'), _defineProperty(_kindToRole, kinds.NOTICE, 'status'), _defineProperty(_kindToRole, kinds.SUCCESS, 'status'), _kindToRole);
  var notificationStyle = {
    styles: /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3652529356",
      children: [".jsx-3652529356{position:fixed;right:10px;top:10px;list-style:none;z-index:999;width:400px;}"]
    }),
    className: "jsx-3652529356"
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TransitionGroup, {
      component: "ul",
      "aria-live": "assertive",
      className: notificationStyle.className,
      children: notifications.map(function (x) {
        var handleClick = preventDefault(function () {
          actions.removeNotification(x.id);
        });
        return /*#__PURE__*/_jsx(CSSTransition, {
          classNames: "item",
          timeout: 300,
          children: /*#__PURE__*/_jsxs("li", {
            role: get(x.kind, '', kindToRole),
            className: "jsx-350160012" + " " + (get(x.kind, '', kindToClassName) || ""),
            children: [/*#__PURE__*/_jsx("div", {
              className: "jsx-350160012" + " " + 'message',
              children: x.msg
            }), x.options.allowManualDimiss ? /*#__PURE__*/_jsx("div", {
              className: "jsx-350160012" + " " + 'close',
              children: /*#__PURE__*/_jsx(CloseButton, {
                onClick: handleClick
              })
            }) : '']
          })
        }, x.id);
      })
    }), notificationStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "350160012",
      children: ["li.jsx-350160012{position:relative;margin-bottom:10px;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;-webkit-align-items:stretch;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;background:white;-webkit-box-shadow:0 0 10px 0 rgba(0,0,0,0.3);box-shadow:0 0 10px 0 rgba(0,0,0,0.3);border-radius:4px;}", "li.jsx-350160012:before{content:'';display:block;-webkit-box-flex:0;-ms-flex:0 0 41px;-webkit-flex:0 0 41px;-ms-flex:0 0 41px;flex:0 0 41px;border-radius:4px 0 0 4px;}", "li.kind-error.jsx-350160012:before{background:#E20000 url('/images/icons/icon-exclamation-point-white.svg') center 16px no-repeat;}", "li.kind-notice.jsx-350160012:before{background:#FFDD15 url('/images/icons/icon-exclamation-point-white.svg') center 16px no-repeat;}", "li.kind-success.jsx-350160012:before{background:#468EE5 url('/images/icons/icon-checkmark-white.svg') center 16px no-repeat;}", "li.item-enter.jsx-350160012{opacity:0;left:100%;-webkit-transform:scale(0);-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);}", "li.item-enter-active.jsx-350160012{-webkit-transition:all 300ms ease-in;-webkit-transition:all 300ms ease-in;transition:all 300ms ease-in;left:0;opacity:1;-webkit-transform:scale(1);-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}", "li.item-exit.jsx-350160012{opacity:1;overflow:hidden;left:0;margin-top:0;-webkit-transform:scale(1);-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}", "li.item-exit-active.jsx-350160012{-webkit-transition:all 300ms ease-in;-webkit-transition:all 300ms ease-in;transition:all 300ms ease-in;-webkit-transform:scale(0);-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:0;left:100%;margin-top:-50px;}", ".message.jsx-350160012{-webkit-box-flex:1;-ms-flex-positive:1;-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;padding:12px 10px 10px;}", ".close.jsx-350160012{padding:10px;}"]
    })]
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);